import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { notification } from "antd";

export function Notification({ message, slice, variant, type, _type = undefined, actions, time, actionName = undefined }, ...rest) {
  const dispatch = useDispatch();
  let style = {
    backgroundColor: "white",
  };

  useEffect(() => {
    if (!!actions) {
      if (actionName) {
        dispatch(actions[actionName]({ url: null, status: null }));
      } else {
        if (variant.length && typeof variant !== "string") {
          dispatch(actions?.updateMessage(variant[0], null));
          dispatch(actions?.updateMessage(variant[1], null));
        } else {
          if (_type) {
            dispatch(actions?.updateMessage(_type, null));
          } else {
            dispatch(actions?.updateMessage(type, null));
          }
        }
      }
    }
  }, []);

  if (!slice) {
    return (
      <>
        {typeof message === "object"
          ? message?.map((msg) => notification[type]({ message: msg, duration: type == "success" ? 3 : 5, style: { ...style } }))
          : notification[type]({ message: message, duration: type == "success" ? 3 : 5, style: { ...style } })}
      </>
    );
  } else {
    return (
      <>
        {typeof message === "object"
          ? message?.map((msg) =>
              notification[type]({
                message: msg.split("->")[2],
                duration: type == "success" ? 3 : 5,
                style: { ...style },
              })
            )
          : notification[type]({ message: message, duration: type == "success" ? 3 : 5, style: { ...style } })}
      </>
    );
  }
}
